var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0255 1.45668L16.1463 15.0354C15.929 15.9937 15.3625 16.2322 14.5575 15.7808L10.1704 12.5479L8.05362 14.5839C7.81944 14.8182 7.62345 15.0141 7.17196 15.0141L7.48712 10.546L15.6181 3.19872C15.9716 2.88357 15.5415 2.70891 15.0687 3.0241L5.01676 9.35342L0.689303 7.99899C-0.252003 7.70508 -0.269009 7.05764 0.885204 6.6062L17.8117 0.0852089C18.5953 -0.208664 19.2811 0.259791 19.0255 1.45668Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.137aa6d5cec72717f70ec21614e76003.svg";
export { ForwardRef as ReactComponent };